// extracted by mini-css-extract-plugin
export var aircallIframe = "_is-3";
export var fabContainer = "_is-5";
export var fabRinging = "_is-6";
export var loadingOverlay = "_is-4";
export var pulse = "_is-7";
export var widgetContent = "_is-2";
export var widgetPanel = "_is-0";
export var widgetPanelExpanded = "_is-1";